import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["$spaceCssStyles"],
  _excluded2 = ["$spaceCssStyles"],
  _excluded3 = ["className"];
import styled from 'styled-components';
import { forwardRef } from 'react';
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { filterTokenProps } from 'foundations-components/utils/filterTokenProps';
import { jsx as _jsx } from "react/jsx-runtime";
export function createTokenizedComponentWithRef(Component) {
  const StyledComponent = styled( /*#__PURE__*/forwardRef((_ref, ref) => {
    let props = _objectWithoutPropertiesLoose(_ref, _excluded);
    return /*#__PURE__*/_jsx(Component, Object.assign({}, props, {
      ref: ref
    }));
  }))(({
    $spaceCssStyles
  }) => {
    return Object.assign({}, $spaceCssStyles);
  });
  return function TokenizedComponent(props) {
    const {
      tokenProps,
      restProps
    } = filterTokenProps(props);
    const spaceCssStyles = useMapTokenPropsToCSS(tokenProps);
    return (
      /*#__PURE__*/
      /* @bend-expect trellis-tokenized */
      _jsx(StyledComponent, Object.assign({}, restProps, {
        ref: restProps.inputRef,
        $spaceCssStyles: spaceCssStyles
      }))
    );
  };
}
export function createTokenizedComponent(Component) {
  const StyledComponent = styled(_ref2 => {
    let props = _objectWithoutPropertiesLoose(_ref2, _excluded2);
    return /*#__PURE__*/_jsx(Component, Object.assign({}, props));
  })(({
    $spaceCssStyles
  }) => {
    return Object.assign({}, $spaceCssStyles);
  });
  return function TokenizedComponent(props) {
    const {
      tokenProps,
      restProps
    } = filterTokenProps(props);
    const spaceCssStyles = useMapTokenPropsToCSS(tokenProps);

    // we are being careful here about which props are passed, and
    // using the appropriate hook to get spaceCssStyles
    /* @bend-expect trellis-tokenized */
    return /*#__PURE__*/_jsx(StyledComponent, Object.assign({}, restProps, {
      $spaceCssStyles: spaceCssStyles
    }));
  };
}
export function withoutClassName(props) {
  const rest = _objectWithoutPropertiesLoose(props, _excluded3);
  return rest;
}